import React, { Component, Fragment } from 'react'

// import ScrollAnimation from 'react-animate-on-scroll'



import { LineContent } from './'

class ProcessPage extends Component{
  render(){
    return(
        <Fragment> 
          <div className="Process">
            <section className="pro-masthead">
              <div className="container">
                <div className="row center-xs">
                  <div className="col-xs-6">
                    <div className="box">
                      <h1>At afrodesiamedia our process begins with the following..</h1>
                    </div>

                  </div>
                </div>
              </div>
            </section>

             <LineContent/>

          </div>   
        </Fragment>
    )
  }
}
export default ProcessPage


// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/pages/Process/components/ProcessPage.js